export default function isProduction() {
  return window.location.host === 'lessonize.com';
}
